module.exports = __webpack_public_path__ + "img/play.f17011ea.svg";